import { useSeo, buildBreadcrumbSchema } from '@/hooks/useSeo';
import { faqs } from '@/mocks/siteContent';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedCollections from './components/FeaturedCollections';
import LatestUpdates from './components/LatestUpdates';
import ValueSection from './components/ValueSection';
import Testimonials from './components/Testimonials';
import FaqSection from './components/FaqSection';
import SubscribeCta from './components/SubscribeCta';

export default function Home() {
  useSeo({
    title: '看瓜爆料 - 合集汇总专题 | 看瓜爆料全集打包 一次看个够',
    description:
      '看瓜爆料合集汇总专题，把零散瓜料按事件、人物、时间线打包整理。看瓜爆料全集、汇总、分类专题一次看个够，省去东翻西找，系统吃透每个爆料的来龙去脉。',
    keywords: '看瓜爆料,看瓜爆料合集,看瓜爆料汇总,看瓜爆料专题,看瓜爆料全集',
    canonical: '/',
  });

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '看瓜爆料',
    alternateName: '看瓜爆料合集汇总专题',
    description:
      '把零散瓜料按事件、人物、时间线打包整理的娱乐合集专题站。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://ijlvv.cn/collections?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  const breadcrumbSchema = buildBreadcrumbSchema([{ name: '首页', path: '/' }]);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <Hero />
      <CategoryNav />
      <FeaturedCollections />
      <LatestUpdates />
      <ValueSection />
      <Testimonials />
      <FaqSection />
      <SubscribeCta />
    </>
  );
}